export default ({ stores }) => () => {

    return stores.settings.find('app').nilRoleId;

};
